import { useCallback } from "react";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";
import { IBroadcastEmailBackEndModel, IUserForBroadcast } from "../types";

export default function () {
  const { request } = useApi();

  return {
    fetchSubscribers: useCallback(async (): Promise<{
      data: IUserForBroadcast[];
    }> => {
      return request({
        method: "GET",
        url: ApiRoutes.GET_SUBSCRIBERS_FOR_BROADCAST,
        shouldHandleError: true,
      });
    }, [request]),
    fetchStudents: useCallback(async (): Promise<{
      data: IUserForBroadcast[];
    }> => {
      return request({
        method: "GET",
        url: ApiRoutes.GET_STUDENTS_FOR_BROADCAST,
        shouldHandleError: true,
      });
    }, [request]),
    fetchAgents: useCallback(async (): Promise<{
      data: IUserForBroadcast[];
    }> => {
      return request({
        method: "GET",
        url: ApiRoutes.GET_AGENTS_FOR_BROADCAST,
        shouldHandleError: true,
      });
    }, [request]),
    fetchParents: useCallback(async (): Promise<{
      data: IUserForBroadcast[];
    }> => {
      return request({
        method: "GET",
        url: ApiRoutes.GET_PARENTS_FOR_BROADCAST,
        shouldHandleError: true,
      });
    }, [request]),
    fetchSchoolUsers: useCallback(async (): Promise<{
      data: IUserForBroadcast[];
    }> => {
      return request({
        method: "GET",
        url: ApiRoutes.GET_SCHOOL_USERS_FOR_BROADCAST,
        shouldHandleError: true,
      });
    }, [request]),
    fetchServiceProviderUsers: useCallback(async (): Promise<{
      data: IUserForBroadcast[];
    }> => {
      return request({
        method: "GET",
        url: ApiRoutes.GET_SERVICE_PROVIDER_USERS_FOR_BROADCAST,
        shouldHandleError: true,
      });
    }, [request]),
    broadcastEmail: useCallback(
      (data: IBroadcastEmailBackEndModel) => {
        return request({
          method: "POST",
          url: `${ApiRoutes.BROADCAST_EMAIL_TO_SELECTED_USERS}`,
          data: data,
        });
      },
      [request],
    ),
  };
}
